import { graphql } from 'react-relay';

export const collectionsLandingRoot = graphql`
    query collectionsLandingRootQuery($landingPreviewId: String, $listPreviewId: String) {
        viewer {
            landingPage: collectionsLandingPage(
                landingPreviewId: $landingPreviewId
                listPreviewId: $listPreviewId
            ) {
                title
                seoTitle
                seoDescription
                ...ShopWrapper_landingPage
            }
        }
    }
`;
